<div class="modal-header">
  <h2>{{ title }}</h2>
  <button
    id="close"
    type="button"
    class="close pull-right"
    (click)="modalRef.hide()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <p [innerHTML]="description"></p>
  <p
    *ngIf="clickText"
    [innerHTML]="clickText"
    (click)="clickAction!.next()"
  ></p>
</div>

<div class="modal-footer">
  <button
    id="cancel"
    class="button-secondary big"
    *ngIf="cancelLabel"
    (click)="cancelAction.next()"
  >
    {{ cancelLabel }}
  </button>
  <button
    id="confirm"
    class="button-primary big"
    (click)="confirmAction.next()"
  >
    {{ confirmLabel }}
  </button>
</div>
